import { render, staticRenderFns } from "./DocumentDetailList31.vue?vue&type=template&id=e1fb7f7e&scoped=true"
import script from "./DocumentDetailList31.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList31.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fb7f7e",
  null
  
)

export default component.exports